module.exports = __webpack_public_path__ + "img/comment-plus.d5601303.svg";